const closers = new Map<string, () => Promise<void>>();

export const registerSwipeableRow = ({
    close,
    id
}: {
    close: () => Promise<void>;
    id: string;
}) => {
    closers.set(id, close);

    return () => {
        closers.delete(id);
    };
};

export const closeOtherSwipeableRows = ({
    id
}: {
    id: string;
}) => {
    const pending: Array<Promise<void>> = [];

    closers.forEach((close, key) => {
        if(key !== id) {
            pending.push(close());
        }
    });

    return Promise.all(pending).then(() => undefined);
};
